<template>
    <div>
        <div class="px-6 py-4">
            <!-- Кнопка сбросить фильтр -->
            <div class="flex cursor-pointer" @click="clearAllSelects">
                <feather-icon icon="LayersIcon" svgClasses="h-6 w-6"></feather-icon>
                <span class="text-lg ml-3">{{$t('show_all')}}</span>
            </div>
        </div>

        <vs-divider class="mb-0 mt-0"></vs-divider>

        <!-- Список селектов (Рендер происходит по структуре) -->
        <MySelect v-for="select in listSelects" :data="select" :key="select.nameI18nAndQueryParam"/>

        <div class="px-6 py-4 lg:hidden">
            <vs-button @click="sidebarToggle()" class="w-full">{{$t('apply')}}</vs-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "Filters",
    props: {
        sidebarToggle: {
            type: Function,
            required: true
        }
    },
    components: {
        MySelect: () => import('@/pages/Home/ApplicationForISC/ApplicationsReview/components/Multiselect')
    },
    data() {
        return {
            listSelects: [
                {
                    nameI18nAndQueryParam: 'study_year',
                    endpoint: 'common/study_years/',
                    required: true,
                    dependents: [
                        'registration_period',
                        'study_form',
                        'faculty',
                        'cathedra',
                        'groupOp',
                        'educational_program',
                        'course',
                        'group',
                        'status',
                    ]
                },
                {
                    nameI18nAndQueryParam: 'reg_period',
                    endpoint: 'common/reg_periods/',
                    required: true,
                    params: [
                        'study_year',
                    ],
                    dependents: [
                        'study_form',
                        'faculty',
                        'cathedra',
                        'groupOp',
                        'educational_program',
                        'course',
                        'group',
                        'status',
                    ]
                },
                {
                    nameI18nAndQueryParam: 'study_form',
                    endpoint: 'common/study_forms/',
                    params: [
                        'study_year',
                        'registration_period',
                    ],
                    dependents: [
                        'faculty',
                        'cathedra',
                        'groupOp',
                        'educational_program',
                        'course',
                        'group',
                        'status',
                    ]
                },
                {
                    nameI18nAndQueryParam: 'faculty',
                    endpoint: 'advisors/faculties/',
                    params: [
                        'study_year',
                        'study_form',
                    ],
                    dependents: [
                        'cathedra',
                        'groupOp',
                        'educational_program',
                        'course',
                        'group',
                        'status',
                    ]
                },
                {
                    nameI18nAndQueryParam: 'cathedra',
                    endpoint: 'advisors/cathedras/',
                    params: [
                        'study_year',
                        'study_form',
                        'faculty',
                    ],
                    dependents: [
                        'groupOp',
                        'educational_program',
                        'course',
                        'group',
                        'status',
                    ]
                },
                {
                    nameI18nAndQueryParam: 'edu_prog_group',
                    endpoint: 'advisors/edu_programs_group/',
                    params: [
                        'study_year',
                        'faculty',
                        'study_form',
                        'cathedra',
                    ],
                    dependents: [
                        'educational_program',
                        'course',
                        'group',
                        'status',
                    ]
                },
                {
                    nameI18nAndQueryParam: 'edu_prog',
                    endpoint: 'advisors/edu_programs/',
                    params: [
                        'study_year',
                        'faculty',
                        'study_form',
                        'cathedra',
                        'groupOp'
                    ],
                    dependents: [
                        'course',
                        'group',
                        'status',
                    ]
                },
                {
                    nameI18nAndQueryParam: 'course',
                    endpoint: 'common/courses/',
                    dependents: [
                        'group',
                        'status',
                    ]
                },
                {
                    nameI18nAndQueryParam: 'group',
                    endpoint: 'advisors/groups/',
                    params: [
                        'study_year',
                        'faculty',
                        'study_form',
                        'cathedra',
                        'groupOp',
                        'educational_program',
                        'course',
                    ],
                    dependents: [
                        'status',
                    ]
                },
                {
                    nameI18nAndQueryParam: 'status',
                    endpoint: 'common/student_discipline/status/',
                    params: [
                        'study_year',
                        'faculty',
                        'study_form',
                        'cathedra',
                        'groupOp',
                        'educational_program',
                        'course',
                    ],
                }
            ]
        }
    },
    methods: {
        clearAllSelects(){
            this.$router.replace({ name: this.$route.name, query: {} });
        },
        checkSelectsDataForRequest(){
            // Получаю массив из обязательных полей из структуры
            const listRequired = this.listSelects.filter(obj => obj.required)
            // Получаю массив из имеющихся заполненных обязательных селектов
            const numberQueryRequired =
                Object.keys(this.$route.query)
                    .filter(key => this.listSelects.some(obj => obj.nameI18nAndQueryParam === key && obj.required))

            // Сравниваю, что все обязательные селекты заполнены и делаю запрос
            if (numberQueryRequired.length === listRequired.length){
                this.$emit('getDataOfStudents')
            } else {
                this.$emit('clearStudentsInList')
            }
        },
    },
    mounted() {
        // Проверка заполнено ли достаточно селектов, чтобы получить список заявок от студентов
        this.checkSelectsDataForRequest()
    },
    watch: {
        '$route.query'(){
            // Проверка заполнено ли достаточно селектов, чтобы получить список заявок от студентов
            this.checkSelectsDataForRequest()
        }
    }
}
</script>

<style scoped lang="scss">

</style>
